import React from "react";
import { motion } from "framer-motion";

const AreasOfExpertise = () => {
  const colors = {
  sectionBg: "#F9FBFA", // Logo ke Sage Green ka bahut light tint (Fresh feel)
  accent: "#D7A19E",    // Logo ka Muted Rose (Silhouette color)
  dark: "#546E7A",      // Logo ka Dark Slate Blue (Main text/Brand color)
  text: "#4A5A64",      // Logo ke blue ka thoda soft version (Better readability)
};

  const expertise = [
    {
      title: "Obstetrics & Gynecology",
      text: "Comprehensive care for women across all stages of life, from adolescence to menopause. Expertise in managing normal and high-risk pregnancies, preventive gynecology, and holistic women’s health.",
    },
    {
      title: "Assisted Reproductive Technology (ART)",
      text: "Specialized in IVF, ICSI, and IUI with proven success rates. Combines advanced medical technology with personalized care for couples facing infertility challenges.",
    },
    {
      title: "Preventive Oncology",
      text: "Focuses on early detection and prevention of gynecological cancers with advanced screening, counseling, and minimally invasive treatment options.",
    },
    {
      title: "Infertility Investigation & Management",
      text: "Expert in diagnosing complex infertility conditions and creating customized treatment plans — from ovulation induction to advanced fertility procedures.",
    },
    {
      title: "Hysteroscopy & Laparoscopic Surgery",
      text: "Highly skilled in diagnostic and therapeutic hysteroscopy and laparoscopy, enabling minimally invasive treatment of fibroids, cysts, endometriosis, and uterine abnormalities.",
      highlight: true,
    },
    {
      title: "Maternal & Fetal Medicine",
      text: "Advanced care for expectant mothers with high-risk conditions, ensuring safe pregnancy outcomes through specialized monitoring, diagnostics, and personalized treatment plans.",
    },
  ];

  return (
    <section
      className="relative py-20 px-4 sm:px-10 md:px-16 lg:px-32 overflow-hidden"
      style={{ backgroundColor: colors.sectionBg }}
    >
      {/* Background Blobs */}
      <div className="absolute top-0 left-0 w-full h-full pointer-events-none">
        <div className="absolute top-1/3 -left-24 w-72 h-72 sm:w-80 sm:h-80 bg-pink-200 rounded-full blur-[100px] opacity-25" />
        <div className="absolute bottom-1/3 -right-24 w-72 h-72 sm:w-80 sm:h-80 bg-orange-200 rounded-full blur-[100px] opacity-25" />
      </div>

      <div className="relative max-w-7xl mx-auto z-10">
        {/* Heading */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl  font-bold mb-4" style={{ color: colors.dark }}>
            Areas of <span className="" style={{ background: `linear-gradient(90deg, ${colors.accent}, #f6b8b8)`, WebkitBackgroundClip: 'text', color: 'transparent' }}>Expertise</span>
          </h2>
          <p className="text-gray-500 text-base sm:text-lg">
            Advanced care across women's health specialties, blending modern medicine with personalized attention.
          </p>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 sm:gap-10 lg:gap-12">
          {expertise.map((card, idx) => (
            <motion.div
              key={idx}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: idx * 0.1 }}
              className={`group relative p-6 sm:p-8 rounded-3xl border border-white/20 backdrop-blur-md bg-white/40 shadow-lg hover:shadow-2xl hover:scale-105 transition-all duration-500`}
            >
              {/* Top Accent Gradient Line */}
              <div
                className="w-14 h-1 rounded-full mb-6 mx-auto"
                style={{ background: `linear-gradient(90deg, ${colors.accent}, #f6b8b8)` }}
              />

              {/* Title */}
              <h3 className="text-lg sm:text-xl font-semibold mb-4 text-center" style={{ color: colors.dark }}>
                {card.title}
              </h3>

              {/* Description */}
              <p className="text-sm sm:text-base leading-relaxed text-center opacity-80" style={{ color: colors.text }}>
                {card.text}
              </p>

              {/* Highlight Glow */}
              {card.highlight && (
                <div className="absolute inset-0 rounded-3xl border-2 border-pink-300 opacity-20 pointer-events-none animate-pulse" />
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AreasOfExpertise;